import React from 'react';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'Organización y Método',
  src: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779843566/hf_20260527_005028_ec28f041-2821-466d-a44b-5b764ff8d204_qqvw78.webp' // ← Pegá la URL completa
}, {
  label: 'Tomo 2',
  sublabel: 'El Maestro del PAE',
  src: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779843567/hf_20260527_005135_7903c868-a1d7-4626-9ab6-d1270ee9e59e_apehdj.webp' // ← Pegá la URL completa
}, {
  label: 'Tomo 3',
  sublabel: 'Farmacología y Cálculos',
  src: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779843568/hf_20260527_005111_0ae6366b-d20a-48c1-bf6f-3d7543f1ca66_yf638a.webp' // ← Pegá la URL completa
}, {
  label: 'Tomo 4',
  sublabel: 'Técnicas y Procedimientos',
  src: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779843601/hf_20260527_005141_ec644752-e10c-4561-8aa9-42fcb337c0c3_cljdx9.webp' // ← Pegá la URL completa
}, {
  label: 'Tomo 5',
  sublabel: 'Materias Filtro',
  src: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779843603/hf_20260527_005222_42d55c51-9c86-4d6a-8fa5-99cab57cc02d_qclrrd.webp' // ← Pegá la URL completa
}, {
  label: 'Tomo 6',
  sublabel: 'Manual del Profesional',
  src: 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1779843606/hf_20260527_005225_7d5a5dee-e6b5-4ffc-b397-a97dac538310_vwem0u.webp' // ← Pegá la URL completa
}];
const features = ['Todo el contenido de la carrera organizado por eje curricular y materia', 'PAE con NANDA, NIC, NOC y fórmulas de cálculo de dosis listas para usar', 'Casos clínicos resueltos paso a paso por patología y etapa de vida', 'Guías de trabajos prácticos y material de exámenes listo para presentar'];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(240,249,255) 85%, rgb(219,234,254) 100%)'
  }} data-id="element-260">
      <div className="mx-auto max-w-4xl text-center" data-id="element-261">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-blue-700 border border-blue-700/50 bg-blue-700/5 rounded-full px-4 py-1.5" data-id="element-262">
          🏆 El sistema de estudio más completo para estudiantes de Enfermería
          en Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-blue-700 m-0 mb-4" data-id="element-263">
          ENFERMERO TOTAL: CARRERA RESUELTA™
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px] mx-auto" data-id="element-264">
          <strong data-id="element-265">
            6 Tomos + 6 Bonos — Sistema de Estudio Completo — Toda la carrera
            resuelta.
          </strong>
          <br data-id="element-266" />
          +360 páginas · Del primer parcial a la primera guardia · PAE,
          Farmacología y Técnicas · Casos clínicos resueltos · Guías de trabajos
          prácticos · Fórmulas y cálculos de dosis · Material de TPs y exámenes
          · 100% adaptado a la carrera de Enfermería en Argentina.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-267">
          <div className="grid grid-cols-6 gap-3" data-id="element-268">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-269">
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-270">
                  <img src={tome.src} alt={`${tome.label} — ${tome.sublabel}`} width={120} height={160} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-271" />
                </div>
                <div className="text-center" data-id="element-272">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-273">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-274">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-275">
            <div className="whitespace-nowrap bg-blue-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-276">
              6 TOMOS COMPLETOS · DEL PRIMER PARCIAL A LA PRIMERA GUARDIA
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-277">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-blue-700/5 border border-blue-700/20 rounded-xl px-4 py-3 text-left" data-id="element-278">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-blue-700/15 flex items-center justify-center" data-id="element-279">
                <svg className="w-3 h-3 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-280">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-281" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-282">
                {feature}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}